import { CURRENCY, CURRENCY_LOCALE } from "@/config";

type FormatCurrencyOptions = {
  locale?: string;
  currency?: string;
};

export function formatCurrency(
  value: number,
  options: FormatCurrencyOptions = {},
) {
  const { locale = CURRENCY_LOCALE, currency = CURRENCY } = options;

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
  });

  return formatter.format(value);
}

export function getCurrencySymbol(
  currency: string = CURRENCY,
  locale: string = CURRENCY_LOCALE,
): string {
  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).formatToParts(0);

  return parts.find((part) => part.type === "currency")?.value ?? currency;
}

export function formatDate(date: string): string {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return "";
  }

  return parsedDate.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
